import type { VerificationSummary } from "./useSiteListActions";

/**
 * Расшифровка счётчиков проверки доступов под общей полосой прогресса: по
 * каждому виду публикации — сколько доступов и сайтов признано валидными.
 */
export class VerificationBreakdown {
  public static article(summary: VerificationSummary): string {
    return `(xmlRpc: ${summary.articleXmlRpcValidCount}, api: ${summary.articleApiValidCount}, wp-admin: ${summary.articleWpAdminValidCount} credential, plugin: ${summary.sitesPluginArticleValidCount}/${summary.totalSites} сайтов)`;
  }

  public static homepage(summary: VerificationSummary): string {
    return `(api: ${summary.homepageApiValidCount} credential, wp-admin: ${summary.homepageWpAdminValidCount} credential, plugin: ${summary.sitesPluginHomepageValidCount}/${summary.totalSites} сайтов)`;
  }

  public static sitewide(summary: VerificationSummary): string {
    return `(plugin: ${summary.sitesPluginSitewideValidCount}/${summary.sitesPluginCheckedCount} сайтов)`;
  }

  public static linkRemoval(summary: VerificationSummary): string {
    return `(api: ${summary.linkRemovalApiValidCount}, xmlRpc: ${summary.linkRemovalXmlRpcValidCount} credential, plugin: ${summary.sitesPluginLinkRemovalValidCount}/${summary.totalSites} сайтов)`;
  }
}
